(function () {
  // Prefer your mobile form, else fall back to any /search form
  const form =
    document.querySelector('.mobile-header__search') ||
    document.querySelector('.row2-dsk__search') ||
    document.querySelector('form[action*="/search"]');

  if (!form) return;

  const input =
    form.querySelector('input[type="search"][name="q"]') ||
    form.querySelector('input[name="q"]');

  if (!input) return;

  // Ensure dropdown host exists
  let dropdown = document.querySelector('[data-predictive-dropdown]');
  if (!dropdown) {
    dropdown = document.createElement('div');
    dropdown.setAttribute('data-predictive-dropdown', '');
    dropdown.hidden = true;
    form.insertAdjacentElement('afterend', dropdown);
  }

  // ARIA
  form.setAttribute('role', 'search');
  form.setAttribute('aria-haspopup', 'listbox');
  form.setAttribute('aria-expanded', 'false');
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', 'predictive-search-results');

  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id') || '';
  let controller, debounce;

  function open(state) {
    form.setAttribute('aria-expanded', state ? 'true' : 'false');
    dropdown.hidden = !state;
  }

  async function fetchHTML(q) {
    if (controller) controller.abort();
    controller = new AbortController();

    // IMPORTANT: nested resources[...] + correct section_id
    const params = new URLSearchParams({
  q,
  'resources[type]': 'product,collection,article,page',
  'resources[limit]': '5',
  'resources[options][unavailable_products]': 'last', // optional but useful
  section_id: 'predictive-search'
});

    if (previewId) params.set('preview_theme_id', previewId);

    // Optional tuning
    // params.set('resources[options][unavailable_products]', 'last'); // or 'hide'
    // params.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

    const res = await fetch(`/search/suggest.json?${params.toString()}`, { signal: controller.signal });
    if (!res.ok) throw new Error('request failed ' + res.status);

    const data = await res.json();

    // Prefer Section Rendering HTML
let html = '';
if (data.sections) {
  // Some themes don’t use the literal key 'predictive-search'; grab the first section HTML
  html = data.sections['predictive-search'] || Object.values(data.sections)[0] || '';
}

    // Fallback: render from resources JSON so it still works if section_id ever fails
    if (!html) {
      // Fallback: render from resources JSON with images
const prods = data.resources?.results?.products || [];
html = prods.length
  ? `<div id="predictive-search-results">
       <ul class="predictive-search__results-list list-unstyled" role="listbox" aria-labelledby="predictive-search-products">
         ${prods.map((p, i) => {
           const safeTitle = (p.title || '').replace(/"/g, '&quot;');
           const imgUrl = p.featured_image?.url
             ? `${p.featured_image.url}&width=56&height=56&crop=center`
             : '';
           return `
             <li class="predictive-search__list-item" role="option" id="predictive-search-option-${i + 1}">
               <a class="predictive-search__item predictive-search__item--link link link--text" href="${p.url}" aria-label="${safeTitle}">
                 ${imgUrl
                    ? `<img class="predictive-search__image" src="${imgUrl}" alt="${safeTitle}" width="56" height="56" loading="lazy">`
                    : `<div class="predictive-search__image" style="width:56px;height:56px;border-radius:8px;background:#f4f0ee;"></div>`
                 }
                 <div class="predictive-search__item-content">
                   <h3 class="predictive-search__item-heading h5">${safeTitle}</h3>
                 </div>
               </a>
             </li>`;
         }).join('')}
       </ul>
     </div>`
  : '';
    }

    dropdown.innerHTML = html || '<div class="predictive-search__empty">No suggestions</div>';
    open(Boolean(html));
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debounce);
    if (q.length < 2) { open(false); return; }
    debounce = setTimeout(() => fetchHTML(q).catch(() => open(false)), 160);
  });

  // Close behavior
  document.addEventListener('keydown', e => { if (e.key === 'Escape') open(false); });
  document.addEventListener('click', e => {
    if (!form.contains(e.target) && !dropdown.contains(e.target)) open(false);
  });
  form.addEventListener('submit', () => open(false));
})();

(function () {
  const dropdown = document.querySelector('[data-predictive-dropdown]');
  if (!dropdown) return;

  // Per-variant timers + target quantities
  const pending = new Map(); // vid -> { qty, timer }

  // Fast DOM helpers
  const getCountEl = (ctrl) => ctrl.querySelector('.ps-count');
  const getQtyFromDom = (ctrl) => {
    const el = getCountEl(ctrl);
    const n = parseInt((el?.textContent || '0').trim(), 10);
    return Number.isFinite(n) ? n : 0;
  };
  const setQtyInDom = (ctrl, qty) => {
    const el = getCountEl(ctrl);
    if (el) el.textContent = qty;
  };

  // Single request that sets final quantity (coalesced)
  async function pushQuantity(vid, qty) {
    // /cart/update.js lets us set final qty in one go
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: { [vid]: qty } }),
      keepalive: true
    });
  }

  // Debounced sender per variant id
  function scheduleSend(ctrl, vid, targetQty) {
    const existing = pending.get(vid);
    if (existing && existing.timer) clearTimeout(existing.timer);

    const timer = setTimeout(async () => {
      try {
        await pushQuantity(vid, targetQty);
        // optional: reconcile after success (lightweight)
        // (we already set the DOM optimistically)
      } finally {
        pending.delete(vid);
      }
    }, 180); // 150–250ms feels great for rapid taps

    pending.set(vid, { qty: targetQty, timer });
  }

  // Optional: a light, debounced reconcile with the real cart
  let reconcileTimer = null;
  async function reconcileCounts() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      const qtyOf = (vid) => {
        const it = cart.items.find(i => i.id === Number(vid));
        return it ? it.quantity : 0;
      };
      dropdown.querySelectorAll('.ps-controls').forEach(ctrl => {
        const vid = ctrl.getAttribute('data-variant-id');
        if (!vid) return;
        // If we have a pending local target, prefer that; else set from cart
        if (!pending.has(Number(vid))) setQtyInDom(ctrl, qtyOf(vid));
      });
    } catch {}
  }
  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(reconcileCounts, 400);
  }

  // Keep dropdown open when clicking controls
  dropdown.addEventListener('mousedown', (e) => {
    if (e.target.closest('.ps-controls')) e.preventDefault();
  });

  dropdown.addEventListener('click', (e) => {
    const minus = e.target.closest('.ps-minus');
    const plus  = e.target.closest('.ps-plus');
    if (!minus && !plus) return;

    e.preventDefault();
    e.stopPropagation();

    const ctrl = e.target.closest('.ps-controls');
    const vidStr = ctrl?.getAttribute('data-variant-id');
    if (!vidStr) return;
    const vid = Number(vidStr);

    // 1) read current from DOM, not from /cart.js
    const current = getQtyFromDom(ctrl);
    const delta = plus ? 1 : -1;
    const next = Math.max(0, current + delta);

    // 2) optimistic update — instant UI
    setQtyInDom(ctrl, next);

    // 3) coalesce network calls — send only final qty after taps settle
    scheduleSend(ctrl, vid, next);

    // 4) occasionally reconcile to the real cart (debounced)
    scheduleReconcile();
  });

  // Initial light reconcile when dropdown renders
  const mo = new MutationObserver(() => scheduleReconcile());
  mo.observe(dropdown, { childList: true, subtree: true });
  scheduleReconcile();
})();


/* ---------- Add-to-cart controls enhancer (non-invasive) ---------- */
(function () {
  const DROPDOWN_SEL = '[data-predictive-dropdown]';
  const LIST_SEL = '#predictive-search-results-list';
  const ITEM_SEL = '.predictive-search__list-item';
  const LINK_SEL = '.predictive-search__item--link, .predictive-search__item.link';

  const dropdown = document.querySelector(DROPDOWN_SEL);
  if (!dropdown) return;

  // Create controls markup
  function createControls(handle, variantId, sku) {
    const wrap = document.createElement('div');
    wrap.className = 'ps-controls';
    if (variantId) wrap.dataset.variantId = String(variantId);
    if (handle)    wrap.dataset.handle = handle;
    if (sku)       wrap.dataset.sku = sku;

    wrap.innerHTML = `
      <button class="ps-btn ps-minus" type="button" aria-label="Decrease">−</button>
      <span class="ps-count" data-count>0</span>
      <button class="ps-btn ps-plus"  type="button" aria-label="Increase">+</button>
    `;
    return wrap;
  }

  // Parse handle from /products/<handle>[?...]
  function handleFromUrl(url) {
    try {
      const a = document.createElement('a');
      a.href = url;
      const m = a.pathname.match(/\/products\/([^/]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch { return ''; }
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('product json');
    return res.json();
  }

  async function resolveVariantId(ctrl) {
    if (ctrl.dataset.variantId) return Number(ctrl.dataset.variantId);
    const handle = ctrl.dataset.handle;
    if (!handle) return null;
    const data = await fetchProduct(handle);
    const v = (data.variants || [])[0];
    if (!v) return null;
    ctrl.dataset.variantId = String(v.id);
    if (v.sku && !ctrl.dataset.sku) ctrl.dataset.sku = v.sku;
    return Number(v.id);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart');
    return res.json();
  }

  function qtyInCart(cart, vid) {
    const it = cart.items.find(i => i.id === Number(vid));
    return it ? it.quantity : 0;
  }

  // Enhance current list by injecting controls if missing
  async function enhanceList(root) {
    const list = root.querySelector(LIST_SEL) || root.querySelector('ul');
    if (!list) return;

    list.querySelectorAll(ITEM_SEL).forEach(li => {
      if (li.querySelector('.ps-controls')) return;

      const link = li.querySelector(LINK_SEL);
      if (!link) return;

      const handle = handleFromUrl(link.getAttribute('href') || '');
      const controls = createControls(handle, null, null);

      // Make row layout: let li host both link and controls side-by-side
      li.classList.add('ps-row-host'); // CSS hook (see below)
      li.appendChild(controls);
    });

    // Try to set counts if we already know variant ids
    try {
      const cart = await fetchCart();
      list.querySelectorAll('.ps-controls').forEach(ctrl => {
        const vid = ctrl.dataset.variantId;
        const countEl = ctrl.querySelector('.ps-count');
        if (vid && countEl) countEl.textContent = qtyInCart(cart, vid);
      });
    } catch {}
  }

  // Delegate clicks for + / −
  dropdown.addEventListener('click', async (e) => {
    const plus  = e.target.closest('.ps-plus');
    const minus = e.target.closest('.ps-minus');
    if (!plus && !minus) return;

    const ctrl = e.target.closest('.ps-controls');
    if (!ctrl) return;

    e.preventDefault();
    e.stopPropagation();

    try {
      let vid = await resolveVariantId(ctrl);
      if (!vid) return;

      // Get current quantity from cart
      const cart = await fetchCart();
      const current = qtyInCart(cart, vid);

      if (plus) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: vid, quantity: 1 })
        });
      } else if (minus && current > 0) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: vid, quantity: current - 1 })
        });
      }

      // Refresh this one count
      try {
        const newCart = await fetchCart();
        const countEl = ctrl.querySelector('.ps-count');
        if (countEl) countEl.textContent = qtyInCart(newCart, vid);
      } catch {}
    } catch {
      // swallow errors to never break predictive search
    }
  });

  // Observe dropdown content changes (whenever your existing code re-renders it)
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      if (m.type === 'childList') {
        m.addedNodes.forEach(n => {
          if (n.nodeType === 1) enhanceList(n);
        });
      }
    }
  });
  mo.observe(dropdown, { childList: true, subtree: true });

  // First pass
  enhanceList(dropdown);
})();

(function () {
  function nukeControls(root = document) {
    root.querySelectorAll(
      '.ps-controls, .ps-btn, .ps-minus, .ps-plus, .ps-qty,' +
      ' button[aria-label*="add to cart" i], button[aria-label*="plus" i], button[aria-label*="minus" i]'
    ).forEach(el => el.remove());
  }

  // Run once now
  nukeControls();

  // Run after predictive search re-renders
  const host = document.querySelector('[data-predictive-dropdown]') || document.body;
  new MutationObserver(muts => {
    for (const m of muts) {
      if (m.addedNodes && m.addedNodes.length) nukeControls();
    }
  }).observe(host, { childList: true, subtree: true });

  // Optional: expose for your render pipeline
  window.__hidePsControls = nukeControls;
})();
